import {styled} from '../../styled-components';

/**
 * Container for dialog content.
 */
export const DialogContentStyle = styled.div`
    flex: 1 1 auto;
    overflow-y: auto;
    padding: ${props => props.theme.spacing.units(2, 5)};
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: ${props => props.theme.typography.fontSize};
    background: ${props => props.theme.color.primary.light};
    color: ${props => props.theme.color.text};

    @media only screen and (min-width: 1200px) {
        padding: ${props => props.theme.spacing.units(2, 10)};
    }
`;

DialogContentStyle.displayName = 'DialogContentStyle';
